// Frontend route paths
export const CHECK_EMAIL_PATH = '/checkemail';
export const FARM_PLAN_PREVIEW_PAGE_PATH = '/farm-plan-preview';
export const FARMS_PAGE_PATH = '/farms';
export const FORGET_PASSWORD_PATH = '/forgetpassword';
export const GLOBAL_CATALOGUE_PATH = '/gc';
export const HOME_PAGE_PATH = '/';
export const LIME_MATE_PAGE_PATH = '/limemate';
export const LOGIN_PATH = '/login';
export const ORGANISATIONS_PAGE_PATH = '/organisations';
export const PADDOCK_PLAN_PREVIEW_PAGE_PATH = '/paddock-plan-preview';
export const PROFILE_PATH = '/profile';
export const RESET_PASSWORD_PATH = '/resetpassword';
export const SIGNUP_PATH = '/signup';
export const VERIFICATION_PATH = '/verification';

// Farms page — URL query param names (OP-2260)
export const FARMS_URL_PARAM_NODE = 'node' as const;
export const FARMS_URL_PARAM_TAB = 'tab' as const;
export const FARMS_URL_PARAM_LENS = 'lens' as const;
export const FARMS_URL_PARAM_GROUP_BY = 'groupBy' as const;
export const FARMS_URL_PARAM_YEAR = 'year' as const;
/** Farm Diagnostics lens — absent means the default for the current scope. */
export const FARMS_URL_PARAM_DIAGNOSTICS_LENS = 'dlens' as const;
// Plan previews — the version and switched-on sections travel in the URL so a
// copied link reopens the same configured document (OP-2490).
export const PLAN_PREVIEW_URL_PARAM_BASIS = 'basis' as const;
export const PLAN_PREVIEW_URL_PARAM_SECTIONS = 'sections' as const;
export const PLAN_PREVIEW_URL_BASIS_ACTUAL = 'actual' as const;
export const PLAN_PREVIEW_URL_PARAM_ROTATION_YEARS = 'rotationYears' as const;

export const ORG_KEY_PREFIX = 'org-';
export const FARM_KEY_PREFIX = 'farm-';
export const PADDOCK_KEY_PREFIX = 'paddock-';
export const INPUT_KEY_PREFIX = 'input-';
export const CROP_KEY_PREFIX = 'crop-';
